export function checkIfActionsAllowedPath(pathChain = []) {
  if (
    pathChain.length === 2 &&
    pathChain[1].isDir &&
    pathChain[1].name === "Breakouts"
  )
    return false;
  else return true;
}
